import MarginBox from './MarginBox'

export default MarginBox
